import axios from '@/plugins/axios/contactApi'

export default {
    QUICK_CONTACT: async ({ commit, getters }, payload) => {
        commit('SET_ERROR', false)
        commit('SET_LOADER', true)
        // var config = {
        //   headers: {
        //     'Content-Type': 'application/json',
        //     Authorization: 'Bearer ' + getters.getToken
        //   }
        // }
        try {
            let response = await axios.post('createContact', payload)
            commit('SET_LOADER', false)
            commit('SNACKBAR', {
                snackbar: true,
                message: response.data.message,
                type: 'success'
            })
            console.log(response)
        } catch (error) {
            commit('SET_LOADER', false)
            commit('SET_ERROR', true)
            commit('SNACKBAR', {
                snackbar: true,
                message: error.response.data.message,
                type: 'error'
            })
            console.log(error)
        }
    },
    GET_CONTACTS: async ({ commit, getters }) => {
        commit('SET_ERROR', false)
        commit('SET_LOADER', true)
        var config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + getters.getToken
            }
        }

        return new Promise((resolve, reject) => {
            axios
                .get('allContacts', config)
                .then(res => {
                    commit('SET_LOADER', false)
                    resolve(res.data.contacts)
                })
                .catch(err => {
                    reject(err)
                    commit('SET_LOADER', false)
                    commit('SET_ERROR', true)
                })
        })
    },
}